var _path, _line;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFilter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 16,
    viewBox: "0 0 14 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.38953 2.50806C0.996323 1.84143 1.47691 1 2.25086 1H11.7491C12.5231 1 13.0037 1.84143 12.6105 2.50806L9.01368 8.60583C8.92289 8.75974 8.875 8.93518 8.875 9.11388V12.816C8.875 13.0054 8.768 13.1785 8.59861 13.2632L5.84861 14.6382C5.51616 14.8044 5.125 14.5627 5.125 14.191V9.11388C5.125 8.93518 5.07711 8.75974 4.98632 8.60583L1.38953 2.50806Z",
    stroke: "white",
    strokeWidth: 1.2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 5,
    y1: 8.9,
    x2: 9,
    y2: 8.9,
    stroke: "white",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilter);
export default __webpack_public_path__ + "static/media/Filter.e51030552870a8043141bb7892b11c5b.svg";
export { ForwardRef as ReactComponent };